import { eCDNConfiguration } from './ecdn.types';
import { ILogos } from './projects.types';
import { SingleSignOnTypes } from './registration.types';

export interface Channel {
  channel: number;
  uuid: string;
  name: string;
  url: string;
  customizations: {
    html: {
      events: {
        all: string; //for all events
        [key: string]: string; //key is the event id for a single event
      };
      sessions: {
        all: string; //for all sessions
        [key: string]: string; //key is the session id for a single session
      };
    };
    css: {
      events: string;
      sessions: string;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any; //these can be named anything and be of any value, but html and css are constant and must exist
  };
  legacy: {
    ustream_id: string;
    stream_key: string;
    wistia_id: string;
  };
  logos: ILogos;
  primary_contact?: number | null;
  colors: {
    primary: string;
  };
  email: CustomEmailSender;
  two_factor: boolean;
  enable_api_key: boolean;
  api_token: string | null;
  subscription: number; // will be enumerated once we know more about the subscription levels
  modules: number[]; // may be deprecated
  custom_reactions: CustomReaction[];
  enable_support_chat_widget?: boolean;
  auth_type?: AuthType[] | null;
  auth_integration?: ChannelSSOIntegration | ChannelOauthIntegration | null;
  enable_anonymous_sentiment_reporting?: boolean;
  limit_registration_question_creation?: boolean;
  enabled_features?: string[];
  ecdn_configuration?: eCDNConfiguration;
  event_count?: number;
  type?: ChannelType;
  // New parameters must be optional or nullable
}

export enum ChannelType {
  Webinar = 'Webinar',
  Townhall = 'Townhall',
  VirtualPro = 'VirtualPro',
}

export interface CustomEmailSender {
  sender: string; // name of sender
  sender_signature: string; // email address of sender
  signature_id: number | null; // postmark id of signature needed to check verification, edit, or delete
  verified: boolean; // email address verified by Postmark
  // New parameters must be optional or nullable
}

export interface CustomReaction {
  id: number;
  uuid: string;
  channel: number;
  name: string;
  url: string;
  // New parameters must be optional or nullable
}

export enum AuthType {
  sso = 'sso',
  email_password = 'email_password',
}

export type ChannelSSOIntegration = {
  type: SingleSignOnTypes.OIDC | SingleSignOnTypes.SAML;
  admin_login: boolean;
  idp_name: string;
  user_pool_client_id: string;
  login_text: string | null;
  icon: string | null;
  channel: number;
  uuid: string;
  domain?: string;
};

export type ChannelOauthIntegration = {
  type: SingleSignOnTypes.OAUTH2;
  admin_login: boolean;
  login_text: string | null;
  icon: string | null;
  channel: number;
  uuid: string;
  domain?: string;
};
